import React, { useEffect } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import CommonLabelsPage from "./pages/CommonLabelsPage";
import HomePageEditor from "./pages/HomePageEditor";
import AboutPageEditor from "./pages/AboutPageEditor";
import SolutionsPageEditor from "./pages/SolutionsPageEditor";
import ContactPageEditor from "./pages/ContactPageEditor";
import CmsIconTabNav from "./components/CmsIconTabNav";
import CmsShellHeader from "./components/CmsShellHeader";
import { CMS_WEBSITE_TABS } from "./constants";
import "./cmsWebsite.css";

function CmsWebsite({ match, location }) {
  const basePath = match.path;
  const pathname = location.pathname;
  const activeTab = CMS_WEBSITE_TABS.find((tab) =>
    pathname.includes(`${basePath}/${tab.id}`)
  )?.id || "common";

  useEffect(() => {
    document.body.classList.add("cms-website-active");
    return () => document.body.classList.remove("cms-website-active");
  }, []);

  return (
    <div className="cms-website-layout">
      <div className="cms-website-page">
        <div className="cms-website-tabs-shell">
          <CmsShellHeader />
          <div className="cms-website-tabs-bar">
            <span className="cms-website-tabs-bar__label">Pages</span>
            <div className="cms-website-tabs-scroll">
              <CmsIconTabNav
                tabs={CMS_WEBSITE_TABS}
                activeId={activeTab}
                basePath={basePath}
              />
            </div>
          </div>
          <div className="cms-website-content-wrap">
            <div className="cms-website-route-outlet">
              <Switch>
                <Route exact path={basePath} render={() => <Redirect to={`${basePath}/common`} />} />
                <Route path={`${basePath}/common`} component={CommonLabelsPage} />
                <Route path={`${basePath}/home`} component={HomePageEditor} />
                <Route path={`${basePath}/about`} component={AboutPageEditor} />
                <Route path={`${basePath}/solutions`} component={SolutionsPageEditor} />
                <Route path={`${basePath}/contact`} component={ContactPageEditor} />
                <Redirect to={`${basePath}/common`} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(CmsWebsite);
